import { FormControl, ListItemText, makeStyles, MenuItem, Select } from "@material-ui/core";
import { ChangeEvent, FC, memo, useCallback, useEffect, useState } from "react";

interface SelectApiFieldProps {
  value: number | null;
  onChange: (value: number) => void;
  api: () => Promise<any>;
  renderValue: (arg: any) => any;
  hasAllOption?: boolean;
  allLabel?: string;
}

const MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: 208,
      width: 240,
    },
  },
  variant: "menu" as const,
  getContentAnchorEl: null,
  anchorOrigin: { vertical: "bottom" as const, horizontal: "center" as const },
  transformOrigin: { vertical: "top" as const, horizontal: "center" as const },
};

export const SelectApiField: FC<SelectApiFieldProps> = memo(
  ({ value, onChange, api, renderValue, hasAllOption, allLabel = "All" }) => {
    const classes = useStyles();
    const [options, setOptions] = useState<any[]>([]);

    useEffect(() => {
      api()
        .then((res: any) => {
          const results = res.data?.results ?? [];
          setOptions([...results].sort((a: any, b: any) => a.id - b.id));
        })
        .catch(() => setOptions([]));
    }, [api]);

    const handleChange = useCallback(
      (e: ChangeEvent<{ value: unknown }>) => {
        onChange(Number(e.target.value));
      },
      [onChange],
    );

    return (
      <FormControl className={classes.root}>
        <Select
          fullWidth
          className={!value && !hasAllOption ? classes.noSelectionOption : ""}
          variant="outlined"
          value={value ? value : 0}
          onChange={handleChange}
          MenuProps={MENU_PROPS}
        >
          {hasAllOption ? (
            <MenuItem key={0} value={0}>
              <ListItemText primary={allLabel} />
            </MenuItem>
          ) : (
            <MenuItem key={0} value={0} disabled>
              No selection
            </MenuItem>
          )}
          {options.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              <ListItemText primary={renderValue(item)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  },
);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
  },
  noSelectionOption: {
    color: "#00000075",
  },
}));
